/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · German (de) string table — Shop landing page
   English is the source of truth in the HTML; this file supplies the
   German counterpart for each shop.* key. Missing keys fall back to
   English (see i18n.js). Claim-bearing copy: faithful renderings only,
   no strengthening or embellishment. The only standing discount is the
   routine-builder 10% (auto-applied at checkout for 2+ serums).

   House voice: calm, exact, short. No em dashes in prose (use periods,
   commas, or the mid-dot · ). EXCEPTION: combo card labels keep the
   existing em dash ("Serum C — Brightening"), mirrored faithfully.
   Informal "du". Product names, prices and proper nouns stay as-is.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.de = window.TD_I18N.de || {};
  Object.assign(window.TD_I18N.de, {

    /* ── Nav (page-specific) ── */
    'shop.nav.build': 'Stell eine Routine zusammen',

    /* ── Serum grid ── */
    'shop.grid.title': 'Hautpflege ohne Kompromisse',
    'shop.addcart': 'In den Warenkorb',
    'shop.time.day': 'Tag',
    'shop.time.night': 'Nacht',
    'shop.time.both': 'Tag und Nacht',
    'shop.card.c.benefit': 'Schützt, bringt zum Strahlen und festigt mit reinem Vitamin C.',
    'shop.card.a.benefit': 'Retinol-getriebene Erneuerung, während du schläfst.',
    'shop.card.o.benefit': 'Gibt den Zellen Energie und stellt sichtbare Leuchtkraft wieder her.',
    'shop.card.m.benefit': 'Repariert die Feuchtigkeitsbarriere. Tief und nachhaltig.',
    'shop.card.r.benefit': 'Festigt und stellt wieder her. Reduziert mit der Zeit Unreinheiten und ungleichmäßige Textur.',

    /* ── Benefit strip ── */
    'shop.strip.1.t': 'Ohne Konservierungsstoffe',
    'shop.strip.1.b': 'Airless- und UV-resistente Verpackung, die jeden Wirkstoff schützt. Keine Stabilisatoren, keine Kompromisse.',
    'shop.strip.2.t': 'Transdermale Verabreichung',
    'shop.strip.2.b': 'Ein wasserfreies Trägersystem transportiert aktive Vitamine über die Oberfläche hinaus bis in die Dermis, dort wo Kollagensynthese und Zellerneuerung stattfinden.',
    'shop.strip.3.t': '2 Jahre Haltbarkeit',
    'shop.strip.3.b': 'Kein Wasser bedeutet kein Bakterienwachstum. Stabil und kraftvoll vom ersten bis zum letzten Gebrauch.',
    'shop.strip.4.t': 'Tierversuchsfrei',
    'shop.strip.4.b': 'Nie an Tieren getestet. Klinisch entwickelt, verantwortungsvoll geliefert.',

    /* ── Combo builder ── */
    'shop.combo.label': 'Stell deine Routine zusammen',
    'shop.combo.h2': 'Zwei Seren oder mehr?<br><em>Zehn Prozent Rabatt.</em>',
    'shop.combo.c.name': 'Serum C — Leuchtkraft',
    'shop.combo.c.desc': 'Vitamin C · Tag · Dunkle Flecken und Leuchtkraft',
    'shop.combo.a.name': 'Serum A — Erneuerung',
    'shop.combo.a.desc': 'Vitamin A · Nacht · Zellerneuerung und Textur',
    'shop.combo.o.name': 'Serum O — Oxygenierung',
    'shop.combo.o.desc': 'Vitamin O · Tag · Zelluläre Vitalität und Teint',
    'shop.combo.m.name': 'Serum M — Feuchtigkeit',
    'shop.combo.m.desc': 'Vitamin M · Tag + Nacht · Feuchtigkeit und Barriere',
    'shop.combo.r.name': 'Serum R — Antioxidans',
    'shop.combo.r.desc': 'Resveratrol · Tag + Nacht · Schutz und Langlebigkeit',

    /* ── Combo summary sidebar ── */
    'shop.concern.label': 'Einkaufen nach Hautanliegen',
    'shop.concern.placeholder': 'Wähl ein Anliegen…',
    'shop.concern.firmness': 'Festigkeit',
    'shop.concern.brightness': 'Leuchtkraft',
    'shop.concern.hydration': 'Feuchtigkeit',
    'shop.concern.finelines': 'Feine Linien',
    'shop.concern.darkspots': 'Dunkle Flecken',
    'shop.concern.texture': 'Textur',
    'shop.concern.acnescars': 'Aknenarben',
    'shop.concern.dullness': 'Fahler Teint',
    'shop.sum.title': 'Deine Routine',
    'shop.sum.empty': 'Wähle Seren, um zu beginnen',
    'shop.sum.discount': 'Routinen-Rabatt (10%)',
    'shop.sum.total': 'Gesamt',
    'shop.sum.addbtn': 'Routine in den Warenkorb',
    'shop.sum.note': 'Kostenloser weltweiter Versand · 2 Jahre Haltbarkeit garantiert',

    /* ── Sample / Discovery Kit ── */
    'shop.samp.eyebrow': 'Du weißt nicht, wo du anfangen sollst?',
    'shop.samp.title': 'Probier alle fünf<br><em>für $70.</em>',
    'shop.samp.body': 'Das Transderma Discovery Kit enthält Reiseformate aller fünf Seren. So haben uns die meisten unserer langjährigen Kunden entdeckt.',
    'shop.samp.cta': 'Hol dir das Discovery Kit',
    'shop.samp.fine': '$5 weltweiter Versand · Versendet aus Stockholm',
    'shop.samp.f1.t': 'Alle fünf Seren',
    'shop.samp.f1.b': 'Reiseformate von C, A, O, M und R, je 3 ml. Etwa 7 Tage regelmäßige Anwendung pro Flasche.',
    'shop.samp.f2.t': 'Alle fünf, Seite an Seite',
    'shop.samp.f2.b': 'Setze jede Formel in derselben Woche in deine Routine ein und finde die Kombinationen, die für deine Haut funktionieren.',
    'shop.samp.f3.t': 'Keine Verpflichtung',
    'shop.samp.f3.b': 'Du wirst innerhalb einer Woche wissen, ob Transderma für dich passt. Die meisten wissen es in wenigen Tagen.',

    /* ── Gift voucher ── */
    'shop.gift.title': 'Verschenke <em>Transderma</em>',
    'shop.gift.sub': 'Ein digitaler Gutschein, geliefert per E-Mail. Einlösbar auf jedem Serum und auf dem Discovery Kit.',
    'shop.gift.btn': 'Jetzt kaufen',

    /* ── Discovery Kit product page (shopify-theme/templates/product.transderma-discovery-kit.liquid) ── */
    'shop.kit.crumb.home': 'Startseite',
    'shop.kit.crumb.current': 'Discovery Kit',

    /* Hero */
    'shop.kit.eyebrow': 'Fünf Vitaminseren · Ein Kit',
    'shop.kit.tagline': 'Reiseformate aller fünf Transderma-Seren. Etwa 7 Tage tägliche Anwendung für das gesamte Kit. Teste das ganze System, bevor du dich für die großen Flaschen entscheidest.',
    'shop.kit.price.meta': 'Fünf Miniflaschen · je 3 ml',
    'shop.kit.addcart': 'In den Warenkorb · $70',
    'shop.kit.soldout': 'Ausverkauft · bald wieder verfügbar',
    'shop.kit.reserve': 'Reserviere dein Kit',

    /* Hero meta */
    'shop.kit.meta.inside': 'Was enthalten ist',
    'shop.kit.meta.inside.v': '5 Miniflaschen · je 3 ml',
    'shop.kit.meta.lasts': 'Reichweite',
    'shop.kit.meta.lasts.v': '~7 Tage tägliche Anwendung',
    'shop.kit.meta.formula': 'Formel',
    'shop.kit.meta.formula.v': '100% aktiv, wasserfrei',
    'shop.kit.meta.shelf': 'Haltbarkeit',
    'shop.kit.meta.shelf.v': '2 Jahre, durchgehend kraftvoll',

    /* What's inside */
    'shop.kit.inside.label': 'Was enthalten ist',
    'shop.kit.inside.title': 'Fünf Miniflaschen.<br><em>Eine vollständige Routine.</em>',
    'shop.kit.inside.intro': 'Jede Miniflasche enthält genug Serum für etwa 7 Tage tägliche Anwendung. Verwende sie einzeln, schichte sie morgens und abends, oder teste Kombinationen je nach deinen Anliegen.',
    'shop.kit.card.time.day': 'Tag',
    'shop.kit.card.time.night': 'Nacht',
    'shop.kit.card.time.both': 'Tag + Nacht',
    'shop.kit.card.c.desc': 'Reines Vitamin C. Strahlkraft, Schutz, ebenmäßiger Teint.',
    'shop.kit.card.a.desc': 'Retinol. Zellerneuerung und Textur, während du schläfst.',
    'shop.kit.card.o.desc': 'PQQ. Zellenergie, Vitalität, Klarheit.',
    'shop.kit.card.m.desc': 'Hyaluronsäure. Feuchtigkeit, Fülle, Unterstützung der Barriere.',
    'shop.kit.card.r.desc': 'Resveratrol. Antioxidative Abwehr und Langlebigkeit.',

    /* Why try the kit */
    'shop.kit.why.label': 'Warum hier beginnen',
    'shop.kit.why.title': 'Finde deine Routine, <em>bevor</em> du dich festlegst.',
    'shop.kit.why.intro': 'Eine große Flasche kostet $175 und hält mehrere Wochen täglicher Anwendung. Das Discovery Kit ist der einfachste Weg, herauszufinden, welche Seren auf deiner Haut wirken und welche Kombinationen wirklich den Unterschied für deine spezifischen Anliegen machen.',
    'shop.kit.why.1.t': '~7 Tage echte Anwendung.',
    'shop.kit.why.1.b': 'Genug Serum, um morgens und abends etwa eine Woche lang aufzutragen und Veränderungen in Textur, Teint und Feuchtigkeit zu sehen. Das ist keine Probe, das ist eine laufende Routine.',
    'shop.kit.why.2.t': 'Alle fünf, Seite an Seite.',
    'shop.kit.why.2.b': 'Setze jede Formel in derselben Woche in deine Morgen- und Abendroutine ein. Das Kit ist der schnellste Weg zu lernen, welche Kombinationen wirklich den Unterschied für deine Haut machen.',
    'shop.kit.why.3.t': 'Alle fünf für weniger als eine halbe Flasche.',
    'shop.kit.why.3.b': 'Ein einzelnes großes Transderma-Serum kostet $175. Das Kit gibt dir alle fünf für $70: der wirtschaftlichste Weg, herauszufinden, auf welche Formeln deine Haut wirklich anspricht, bevor du dich entscheidest.',

    /* How it works */
    'shop.kit.how.label': 'So funktioniert es',
    'shop.kit.how.title': 'Sieben Tage. <em>Eine Entdeckung.</em>',
    'shop.kit.how.intro': 'Die meisten Kunden wissen es in fünf Tagen. Hier ist der Weg, den die meisten gehen.',
    'shop.kit.how.s1.t': 'Tag 1 · Öffnen',
    'shop.kit.how.s1.b': 'Öffne das Kit. Wähle das Anliegen, das zu deinem passt: Leuchtkraft, Erneuerung oder Feuchtigkeit.',
    'shop.kit.how.s2.t': 'Tage 1 bis 3 · Testen',
    'shop.kit.how.s2.b': 'Wende deine Routine morgens und abends an. Zwei Tropfen, auf saubere Haut gepumpt. Lass jede Schicht 30 Sekunden einziehen.',
    'shop.kit.how.s3.t': 'Tage 4 bis 7 · Feinabstimmen',
    'shop.kit.how.s3.b': 'Am siebten Tag weißt du, auf welche Seren deine Haut anspricht. Ändere die Routine, schichte anders, oder vereinfache auf zwei.',
    'shop.kit.how.s4.t': 'Tag 8 · Hochskalieren',
    'shop.kit.how.s4.b': 'Bestelle große Flaschen der Seren, die gewirkt haben, in der Routine, die du aufgebaut hast. Zwei Flaschen oder mehr = 10% Rabatt.',

    /* Delivery / returns */
    'shop.kit.del.shipping.t': 'Versand',
    'shop.kit.del.shipping.b': 'Pauschal $5 weltweiter Versand. Versendet aus Stockholm, in der Regel 3 bis 7 Werktage. <a href="/pages/shipping-returns">Vollständige Versanddetails</a>.',
    'shop.kit.del.returns.t': 'Rücksendungen',
    'shop.kit.del.returns.b': 'Einmal geöffnet, ist das Discovery Kit nicht rückerstattbar. Ungeöffnete Kits können innerhalb von 14 Tagen zurückgesendet werden. <a href="/pages/shipping-returns">Rückgaberichtlinie</a>.',
    'shop.kit.del.approved.t': 'Zugelassen und registriert',
    'shop.kit.del.approved.b': 'Laborzugelassen von Läkemedelsverket. Registriert gemäß der europäischen Kosmetikverordnung. Nie an Tieren getestet.'

  });
})();
